import { useEffect, memo, Fragment, useContext } from "react";
import { useLocation, Outlet } from "react-router-dom";

//react-shepherd
import { ShepherdTourContext } from "react-shepherd";

//react-bootstrap
import { Button, Row, Col } from "react-bootstrap";

// header
import Header from "../../components/partials/dashboard/HeaderStyle/header";

//subheader
import SubHeader from "../../components/partials/dashboard/HeaderStyle/sub-header";

//sidebar
import Sidebar from "../../components/partials/dashboard/SidebarStyle/sidebar";

//footer
import Footer from "../../components/partials/dashboard/FooterStyle/footer";
// import BootstrapTable from "../../views/dashboard/table/bootstrap-table"; // DELETED
//default
// import {DefaultRouter} from '../../router/default-router'

//seetingoffCanvas
import SettingOffCanvas from "../../components/setting/SettingOffCanvas";
import Index from "../../../src/views/dashboard/index";

import Loader from "../../components/Loader";

// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";
import HeaderStyle1 from "../../components/partials/dashboard/HeaderStyle/header-style-1";

// Redux Selector / Action
import { useSelector } from "react-redux";

const Tour = () => {
  const tour = useContext(ShepherdTourContext);
  const { pathname } = useLocation();
  useEffect(() => {
    if (
      pathname === "/dashboard" &&
      sessionStorage.getItem("tour") !== "true"
    ) {
      tour?.start();
    }
  });
  return <Fragment></Fragment>;
};

const DefaultForCalendar = memo((props) => {
  const appName = useSelector(SettingSelector.app_name);
  useEffect(() => {
    console.log("hello calling me   no? ");
  });

  return (
    <Fragment>
      <Loader />
      <Sidebar app_name={appName} />
      <Tour />
      <main className="main-content">
        <div className="position-relative">
          <Header />
          <SubHeader />
        </div>
        <div className="conatiner-fluid content-inner ">
          {/* <DefaultRouter /> */}
          {/* <BootstrapTable/> */}
          <Index />
          {/* <Outlet /> */}
        </div>
      </main>
      <SettingOffCanvas />
    </Fragment>
  );
});

DefaultForCalendar.displayName = "DefaultForCalendar";
export default DefaultForCalendar;
